import { default as es } from './es'

const resources = {
  es: { label: 'Español', translations: es, code: 'es' }
}

export default resources
